import colors from 'styles/colors'
import { MINIMUM_FONT_SIZE } from 'styles/typography'

const styles = {
  leftContainer: {
    backgroundColor: colors.white,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 'calc(1rem + 24px)'
  },
  rightContainer: {
    backgroundColor: colors.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 0,
    borderLeft: `1px solid ${colors.whiteSmoke}`,
    borderTop: `1px solid ${colors.whiteSmoke}`
  },
  link: {
    color: colors.primary,
    fontFamily: 'Barlow',
    fontSize: MINIMUM_FONT_SIZE,
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '17px'
  }
}

export default styles
